// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1YqOn","header":"Messages_header__yUzEQ"};